import { FC, ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthUserState } from "../context/authUser.context";
import { pages } from "../utils/common";
import { localStorageGet } from "../utils/localStorage";
import { useSessionTimeout } from "../hooks/useSessionTimeout";
import { canAccessInstituteLevelPages } from "../utils/userTypes";
import MainLayout from "../views/components/mainLayout/mainLayout";

type ProtectedRouteProps = {
  children?: ReactNode;
};

// Routes that require institute-level access
const INSTITUTE_LEVEL_ROUTES = [pages.dashboard.path, pages.institute.path];

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, userDetails } = useAuthUserState();
  const token = localStorageGet("token");
  const location = useLocation();

  // Enable session timeout for authenticated users
  useSessionTimeout();

  // Check if user is authenticated
  if (!isAuthenticated || !token) {
    return <Navigate to={pages.auth.path} replace />;
  }

  // Check if restricted user is trying to access institute-level routes
  const isInstituteLevelRoute = INSTITUTE_LEVEL_ROUTES.some(
    (route) =>
      location.pathname === route || location.pathname.startsWith(route + "/"),
  );

  if (isInstituteLevelRoute && !canAccessInstituteLevelPages(userDetails)) {
    // Redirect restricted users to first available configuration page
    return <Navigate to={pages.spocPremise.path} replace />;
  }

  return <MainLayout>{children ? <>{children}</> : <Outlet />}</MainLayout>;
};

export default ProtectedRoute;
